import { NgModule } from '@angular/core';
import { ImageCropperComponent } from 'ngx-image-cropper';

/** ngx-image-cropper v9+ exports a standalone component instead of ImageCropperModule. */
@NgModule({
    imports: [ImageCropperComponent],
    exports: [ImageCropperComponent],
})
export class ImageCropperModule {}
